/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Grid, PageGridContainer, Typography } from '@coursera/cds-core';

import type { ImageFragment } from 'bundles/program-home/__generated__/contentfulTypes';

import _t from 'i18n!nls/org-landing';

type Props = {
  logos: Array<ImageFragment | null>;
};

function SponsorLogos({ logos }: Props) {
  const styles = {
    sponsors: css`
      margin: var(--cds-spacing-400) auto;
    `,

    sponsorHeading: css`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      h2 {
        font-size: 20px;
        font-weight: 600;
        color: var(--cds-color-neutral-primary-weak);
      }
    `,

    sponsorLogoList: css`
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: var(--cds-spacing-600);
      margin: var(--cds-spacing-200) auto;
      padding: var(--cds-spacing-400) 0 !important;
      background-color: var(--cds-color-neutral-background-primary-weak);

      img {
        max-height: var(--cds-spacing-400);
      }
    `,
  };

  if (logos.length === 0) {
    return null;
  }

  return (
    <div>
      <PageGridContainer maxWidth="lg" css={styles.sponsors}>
        <Grid item xs={12} css={styles.sponsorHeading}>
          <Typography variant="h2">{_t('Sponsored by')}</Typography>
        </Grid>
        <Grid item xs={12} css={styles.sponsorLogoList}>
          {logos.map((logo) => (
            <img src={logo?.url ?? ''} alt={logo?.description ?? ''} />
          ))}
        </Grid>
      </PageGridContainer>
    </div>
  );
}

export default SponsorLogos;
